import { useEffect } from "react";

export const TinyAd = () => {
  useEffect(() => {
    // If the script exposes a global init function, call it to render new ads
    if (window.TinyAds?.init) {
      window.TinyAds.init();
    }
  }, []);

  // This is where the ad will appear
  return <div ta-ad-container=""></div>;
};
